import { render, staticRenderFns } from "./KakaoLogout.vue?vue&type=template&id=c544caa0"
import script from "./KakaoLogout.vue?vue&type=script&lang=js"
export * from "./KakaoLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports